export default "__VITE_PUBLIC_ASSET__1b22c0ba__"